/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { useTranslation } from 'react-i18next';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';

import { Typography, Tooltip, IconButton } from '@mui/material';
import { Link } from 'daaas-ui';

import Icon from '@mdi/react';

import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import {
  mdiTable,
  mdiWaves,
  mdiDatabase,
  mdiFactory,
  mdiWall,
  mdiFlask,
  mdiMonitorDashboard,
  mdiTransitConnectionVariant,
  mdiInformationOutline,
} from '@mdi/js';

export default function caeLinks() {
  const { instance } = useMsal();
  const { t } = useTranslation(['common', 'aaw', 'cae', 'gae']);
  const isAuthenticated = useIsAuthenticated();
  const statCanDomains = ['statcan.gc.ca', 'cloud.statcan.ca'];
  if (
    isAuthenticated &&
    instance.getActiveAccount() &&
    statCanDomains.indexOf(
      instance.getActiveAccount().username.split('@')[1].toLowerCase()
    ) !== -1
  )
    return (
      <>
        <li>
          <Icon path={mdiTransitConnectionVariant} size={1} />
          <Typography component="span" variant="body1">
            <Link
              href={`${t('cae:azureSynapseAnalyticsLink')}`}
              sx={{ ml: 1 }}
              target="_blank"
            >
              Azure Synapse
            </Link>
          </Typography>
          <Tooltip title={t('cae:azureSynapseAnalyticsParagraph')}>
            <IconButton edge="end">
              <Icon path={mdiInformationOutline} size={1} />
            </IconButton>
          </Tooltip>
        </li>
        <li>
          <Icon path={mdiTable} size={1} />
          <Typography component="span" variant="body1">
            <Link
              target="_blank"
              href={`${t('cae:azureBlobStorageLink')}`}
              sx={{ ml: 1 }}
            >
              {t('cae:azureBlobStorageHeading')}
            </Link>
          </Typography>
          <Tooltip title={t('cae:azureBlobStorageParagraph')}>
            <IconButton edge="end">
              <Icon path={mdiInformationOutline} size={1} />
            </IconButton>
          </Tooltip>
        </li>
        <li>
          <Icon path={mdiWaves} size={1} />
          <Typography component="span" variant="body1">
            <Link
              target="_blank"
              href={`${t('cae:azureBlobStorageLink')}`}
              sx={{ ml: 1 }}
            >
              {t('cae:azureDataLakesHeading')}
            </Link>
          </Typography>
          <Tooltip title={t('cae:azureDataLakesParagraph')}>
            <IconButton edge="end">
              <Icon path={mdiInformationOutline} size={1} />
            </IconButton>
          </Tooltip>
        </li>
        <li>
          <Icon path={mdiDatabase} size={1} />
          <Typography component="span" variant="body1">
            <Link
              target="_blank"
              href={`${t('cae:azureSQLDatabaseLink')}`}
              sx={{ ml: 1 }}
            >
              {t('cae:azureSQLDatabaseHeading')}
            </Link>
          </Typography>
          <Tooltip title={t('cae:azureSQLDatabaseParagraph')}>
            <IconButton edge="end">
              <Icon path={mdiInformationOutline} size={1} />
            </IconButton>
          </Tooltip>
        </li>
        <li>
          <Icon path={mdiFactory} size={1} />
          <Typography component="span" variant="body1">
            <Link
              href={t('cae:azureDataFactoryLink')}
              sx={{ ml: 1 }}
              target="_blank"
            >
              Azure Data Factory
            </Link>
          </Typography>
          <Tooltip title={t('cae:azureDataFactoryParagraph')}>
            <IconButton edge="end">
              <Icon path={mdiInformationOutline} size={1} />
            </IconButton>
          </Tooltip>
        </li>
        <li>
          <Icon path={mdiWall} size={1} />
          <Typography component="span" variant="body1">
            <Link
              target="_blank"
              href={`${t('cae:azureDatabricksLink')}`}
              sx={{ ml: 1 }}
            >
              Azure Databricks
            </Link>
          </Typography>
          <Tooltip title={t('cae:azureDatabricksParagraph')}>
            <IconButton edge="end">
              <Icon path={mdiInformationOutline} size={1} />
            </IconButton>
          </Tooltip>
        </li>
        <li>
          <InsertChartOutlinedIcon />
          <Typography component="span" variant="body1">
            <Link
              href={`${t('cae:powerBILink')}`}
              sx={{ ml: 1 }}
              target="_blank"
            >
              Power BI
            </Link>
          </Typography>
          <Tooltip title={t('cae:powerBIParagraph')}>
            <IconButton edge="end">
              <Icon path={mdiInformationOutline} size={1} />
            </IconButton>
          </Tooltip>
        </li>
        <li>
          <Icon path={mdiFlask} size={1} />
          <Typography component="span" variant="body1">
            <Link
              href={`${t('cae:azureMachineLearningLink')}`}
              sx={{ ml: 1 }}
              target="_blank"
            >
              Azure Machine Learning
            </Link>
          </Typography>
          <Tooltip title={t('cae:azureMachineLearningParagraph')}>
            <IconButton edge="end">
              <Icon path={mdiInformationOutline} size={1} />
            </IconButton>
          </Tooltip>
        </li>
        <li>
          <Icon path={mdiMonitorDashboard} size={1} />
          <Typography component="span" variant="body1">
            <Link
              target="_blank"
              sx={{ ml: 1 }}
              href={`${t('cae:azureVirtualMachinesLink')}`}
            >
              {t('cae:azureVirtualMachinesHeading')}
            </Link>
          </Typography>
          <Tooltip title={t('cae:azureVirtualMachinesParagraph')}>
            <IconButton edge="end">
              <Icon path={mdiInformationOutline} size={1} />
            </IconButton>
          </Tooltip>
        </li>
      </>
    );
  if (
    isAuthenticated &&
    instance.getActiveAccount() &&
    instance.getActiveAccount().username.split('@')[1].toLowerCase() ===
      'ext.statcan.ca'
  );
  return (
    <>
      <li>
        <Icon path={mdiFactory} size={1} />
        <Typography component="span" variant="body1">
          <Link
            target="_blank"
            href={t('cae:azureDataFactoryLink')}
            sx={{ ml: 1 }}
          >
            Azure Data Factory
          </Link>
        </Typography>
        <Tooltip title={t('cae:azureDataFactoryParagraph')}>
          <IconButton edge="end">
            <Icon path={mdiInformationOutline} size={1} />
          </IconButton>
        </Tooltip>
      </li>
      <li>
        <Icon path={mdiWall} size={1} />
        <Typography component="span" variant="body1">
          <Link
            target="_blank"
            href={`${t('cae:azureDatabricksLink')}`}
            sx={{ ml: 1 }}
          >
            Azure Databricks
          </Link>
          <Tooltip title={t('cae:azureDatabricksParagraph')}>
            <IconButton edge="end">
              <Icon path={mdiInformationOutline} size={1} />
            </IconButton>
          </Tooltip>
        </Typography>
      </li>
      <li>
        <InsertChartOutlinedIcon />
        <Typography component="span" variant="body1">
          <Link target="_blank" href={`${t('cae:powerBILink')}`} sx={{ ml: 1 }}>
            Power BI
          </Link>
        </Typography>
        <Tooltip title={t('cae:powerBIParagraph')}>
          <IconButton edge="end">
            <Icon path={mdiInformationOutline} size={1} />
          </IconButton>
        </Tooltip>
      </li>
      <li>
        <Icon path={mdiFlask} size={1} />
        <Typography component="span" variant="body1">
          <Link
            target="_blank"
            href={`${t('cae:azureMachineLearningLink')}`}
            sx={{ ml: 1 }}
          >
            Azure Machine Learning
          </Link>
        </Typography>
        <Tooltip title={t('cae:azureMachineLearningParagraph')}>
          <IconButton edge="end">
            <Icon path={mdiInformationOutline} size={1} />
          </IconButton>
        </Tooltip>
      </li>
      <li>
        <Icon path={mdiTransitConnectionVariant} size={1} />
        <Typography component="span" variant="body1">
          <Link
            target="_blank"
            href={`${t('cae:azureSynapseAnalyticsLink')}`}
            sx={{ ml: 1 }}
          >
            Azure Synapse
          </Link>
        </Typography>
        <Tooltip title={t('cae:azureSynapseAnalyticsParagraph')}>
          <IconButton edge="end">
            <Icon path={mdiInformationOutline} size={1} />
          </IconButton>
        </Tooltip>
      </li>
    </>
  );
}
